import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    create: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_price_quotes";

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    showTotal: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_price_quotes/get_current_total_price";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }

}